import React from 'react'
import { compose } from 'ramda'
import { asLayout as mainLayout } from 'components/MainLayout'
import { asLayout as secondaryLayout } from 'components/SecondaryLayout'
import { make as MainAppRelay } from 'v5/MainApp.bs'

export default MainAppRelay

export const asLayout = page => <MainAppRelay>{page}</MainAppRelay>
export const withMainLayout = compose(asLayout, mainLayout({}))
export const withMainLayoutNoPadding = compose(asLayout, mainLayout({ noPadding: true }))
export const withMainLayoutFlex = compose(asLayout, mainLayout({ flexDirection: 'column' }))
export const withMainLayoutFlexNoPadding = compose(
  asLayout,
  mainLayout({ flexDirection: 'column', noPadding: true })
)
export const withSecondaryLayout = compose(asLayout, secondaryLayout)
